export default "__VITE_ASSET__CzFIPXLl__"